<div class="tenant-container">
    <form [formGroup]="tenantForm" (ngSubmit)="onSubmit()">

      <div class="col-12 d-flex">
        <div class="form-group col-6">
          <label for="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            class="form-control" 
            formControlName="first_name"
            placeholder="Enter first name"/>
          <div *ngIf="tenantForm.controls['first_name'].invalid && tenantForm.controls['first_name'].touched" class="error text-danger">
           <small class="text-danger">First name is required.</small>
          </div>
        </div>
        <div class="form-group col-6">
          <label for="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            class="form-control"
            formControlName="last_name"
            placeholder="Enter last name"
          />
          <div *ngIf="tenantForm.controls['last_name'].invalid && tenantForm.controls['last_name'].touched" class="error text-danger">
          <small class="text-danger">Last name is required.</small>
          </div>
        </div>
      </div>

      <div class="col-12 d-flex">
        <div class="form-group col-6">
          <label for="email">Email:</label>
          <input
            type="email"
            id="email"
            class="form-control"
            formControlName="email"
            placeholder="Enter email"
          />
          <div *ngIf="tenantForm.controls['email'].invalid && tenantForm.controls['email'].touched" class="error text-danger">
           <small class="text-danger">Valid email is required.</small>
          </div>
        </div>
        <!-- <div class="form-group col-6">
          <label for="lastName">Password:</label>
          <input
            type="password"
            id="password"
            class="form-control"
            formControlName="password"
            placeholder="Enter Password"
          />
          <div *ngIf="tenantForm.controls['password'].invalid && tenantForm.controls['password'].touched" class="error text-danger">
          <small class="text-danger">Last name is required.</small>
          </div>
        </div> -->
        <div class="form-group col-6">
          <label for="phone">Phone:</label>
          <!-- <input type="tel" id="phone" class="form-control" formControlName="phone" placeholder="Enter Phone" (input)="enforcePrefix($event)" maxlength="16"/> -->
          <input type="tel" id="phone" class="form-control" formControlName="phone" placeholder="xxx-xxx-xxxx" mask="000-000-0000" [validation]="true"/>
          <div class="error text-danger" *ngIf="tenantForm.controls['phone'].invalid && tenantForm.controls['phone'].touched">
            <small class="text-danger" *ngIf="tenantForm.get('phone')?.errors?.['required']">Phone Number is required.</small>
            <small class="text-danger"  *ngIf="tenantForm.get('phone')?.errors?.['invalidUSPhone']">
              Kindly provide a valid US phone number in this formats:
              <code>000-000-0000</code>
              with a valid US area code.
            </small>
          </div>
        </div>
      </div>


       <div class="d-flex justify-content-end mt-2 p-1">
         <p-button type="submit" [disabled]="tenantForm.invalid" class="secondary-btn">Submit</p-button>
       </div>
    </form>
</div>
<p-toast></p-toast>